import { Flex, Icon, Text } from '@chakra-ui/react';
import { MdOutlineNotificationsNone } from 'react-icons/md';

type Props = {
  showDismissed: boolean;
};

const NotificationsZeroState = ({ showDismissed }: Props) => {
  return (
    <Flex
      w="full"
      flexDir="column"
      alignItems="center"
      justifyContent="center"
      p={4}
      color="taupeGray"
    >
      <Icon as={MdOutlineNotificationsNone} boxSize="50px" mb={3} />
      <Text>No {showDismissed ? 'dismissed' : 'new'} notifications</Text>
    </Flex>
  );
};

export default NotificationsZeroState;
